import { change } from 'redux-form';

/**
 * @description Экшен для установки зала, используется при переключении на зал
 */
export const changeSectionToFirstItem = (formName: string, sectionId: number) => change(formName, 'section', sectionId);

export const changeCurrentTime = (formName: string, time: string) => change(formName, 'time', time);
